import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../api/client';

interface Contact { address: string; phones: string; mails: string; }
interface SocialLinksData { instagram: string; facebook: string; telegram: string; }

export default function SocialLinks() {
  const { t } = useTranslation();
  const [contact, setContact] = useState<Contact | null>(null);
  const [socialLinks, setSocialLinks] = useState<SocialLinksData>({ instagram: '', facebook: '', telegram: '' });

  useEffect(() => {
    axios.get(`${API_BASE}/main-contact/all`)
      .then(r => { if (r.data.length > 0) setContact(r.data[0]); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    axios.get(`${API_BASE}/social-links`)
      .then(res => {
        if (res.data.length > 0) {
          setSocialLinks(res.data[0]);
        }
      })
      .catch(() => {});
  }, []);

  const QUICK_LINKS = [
    { label: t('footer_about'),    href: '/' },
    { label: t('nav_activities'),  href: '/activities' },
    { label: t('nav_join'),        href: '/join' },
    { label: t('nav_documents'),   href: '/documents' },
    { label: t('nav_news'),        href: '/news' },
    { label: t('nav_faq'),         href: '/faq' },
  ];

  const SOCIAL_LINKS_DISPLAY = [
    { name: 'Instagram', icon: '📸', href: socialLinks.instagram },
    { name: 'Facebook',  icon: '👥', href: socialLinks.facebook },
    { name: 'Telegram',  icon: '✈️', href: socialLinks.telegram },
  ].filter(s => s.href);

  return (
    <footer className="footer-main">
      <div className="footer-inner">

        <div className="footer-brand">
          <h3 style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '1.05rem', fontWeight: 700, color: '#fff' }}>
            {t('header_org')}
          </h3>
          <p>{t('footer_desc')}</p>
          {SOCIAL_LINKS_DISPLAY.length > 0 && (
            <div className="footer-social-links" style={{ marginTop: 20 }}>
              {SOCIAL_LINKS_DISPLAY.map(s => (
                <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" className="footer-social-btn" title={s.name}>
                  {s.icon}
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="footer-col">
          <h4>{t('footer_nav')}</h4>
          <ul>
            {QUICK_LINKS.map(l => (
              <li key={l.href}><Link to={l.href}>{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t('footer_contacts')}</h4>
          {contact ? (
            <>
              <div className="footer-contact-item"><span>📍</span><span>{contact.address}</span></div>
              {contact.phones.split(',').map((p, i) => (
                <div key={i} className="footer-contact-item">
                  <span>📞</span>
                  <a href={`tel:${p.trim()}`} style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>{p.trim()}</a>
                </div>
              ))}
              {contact.mails.split(',').map((m, i) => (
                <div key={i} className="footer-contact-item">
                  <span>✉️</span>
                  <a href={`mailto:${m.trim()}`} style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>{m.trim()}</a>
                </div>
              ))}
            </>
          ) : (
            <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.5)' }}>{t('footer_loading')}</p>
          )}
        </div>

        <div className="footer-col">
          <h4>{t('footer_hours')}</h4>
          <ul>
            <li><span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.88rem' }}>{t('footer_hours_weekday')}</span></li>
            <li><span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.88rem' }}>{t('footer_hours_weekend')}</span></li>
          </ul>
          <div style={{ marginTop: 20 }}>
            <Link to="/join" style={{ display: 'inline-block', background: '#10b981', color: '#fff', padding: '10px 22px', borderRadius: 8, fontWeight: 600, fontSize: '0.88rem', textDecoration: 'none' }}>
              {t('footer_join_btn')}
            </Link>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} {t('footer_copyright')}
      </div>
    </footer>
  );
}
